import React, { Component } from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import swal from 'sweetalert';

import $ from 'jquery';

import {callerActionHistoryInchreaseCalledTimes, callerActionHistoryListCalled, callerConfiguration, callerConfigurationInitStatus, healthFacilitiesId} from '../../libs/services';
import { Table } from 'react-bootstrap';
import sound from '../../assets/sounds/caller.mp3';
window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');

var Config = require('../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";
var CallerSocket = null;
var message = null;

let mySound = new Audio(sound)

class Caller extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.increaseCalledTimes = this.increaseCalledTimes.bind(this);

		this.state = {
			list_called: [],
			health_facilities_name:"",
			section:""
		}
	}

	async componentWillMount(){
		this._mounted = true;
		var search = this.props.match.url.replace('/', '');        

		//Actualizar listado por mensaje del servidor
      	_hub = $.hubConnection(ChatUrl, {
        	useDefaultPath: false
      	});

      	ChatProxy = _hub.createHubProxy('ChatHub');
      	ChatProxy.getItems = this.getList;

      	ChatProxy.on("addNewMessageToPage", function(name, message) {
	        if(message === "refresh" && search.indexOf('caller') !== -1){
	            this.getItems();
	        }
      	});

      	_hub.start()
      	.done(function() {
        	console.log("Connected to Signalr Server");
      	})
      	.fail(function() {
        	console.log("failed in connecting to the signalr server");
      	});
      	
		this.creaSocket();

		var response = await healthFacilitiesId(this.props.match.params.health_id, this.props.waiting);
		if(response !== undefined){
			this.setState({
				health_facilities_name: response.health_facilities.name
			});
		}

		response = await callerConfigurationInitStatus(this.props.match.params.health_id);
		if(response){
			this.setState({section:response});
		}

        await this.getList();
	}

	creaSocket(){
		CallerSocket = null;
		message = null;

		try{
			CallerSocket = new WebSocket('ws://localhost:2019/');
			console.log('socket llamador creado');
			this.socketActions();
		}catch(error){
			console.log('error socket');
			console.log(error);
		}
	}

	socketActions(){
		if(CallerSocket){
			CallerSocket.onopen = function(event){
				CallerSocket.send('Init');
				console.log('abriendo caller socket')
				if(message){
					CallerSocket.send(message);	
					message = null;
				}
			};

			CallerSocket.onmessage = function(event){
				var res = JSON.parse(event.data);
				
				console.log(JSON.stringify(res));
				if(res.Error){
					console.log(res.Error);
					return;
				}

				if(res.Mensaje){
					console.log(res.Mensaje);
					return
				}
			}
		}
	}

	enviaMensaje(mensaje){
		if(CallerSocket === null || (CallerSocket !== null && CallerSocket.readyState === WebSocket.CLOSED)){
			this.creaSocket();
		}

		if(CallerSocket){
			if(CallerSocket.readyState === WebSocket.CONNECTING){
				message = mensaje;
				return;
			}
			CallerSocket.send(mensaje)
		}else{
			swal('Error', "No fue posible conectar con aplicación HAP", 'error');
		}
	}

	componentWillUnmount(){
		this._mounted = false;
		CallerSocket.close();
		console.log('Cerrando socket')
	}

	async getList(){
		var response = await callerActionHistoryListCalled(this.props.match.params.health_id);
		if(response !== undefined){
			if(this._mounted){				
				this.setState({list_called:response});
				if(response.length > 0){
					setTimeout(function(){//reproducir sonido
						try{
														
							if(response[0].machine_name !== null && response[0].machine_name !== 'NULL' && response[0].called_times === 0 && response[0].section !== this.state.section){
								this.enviaMensaje("Ficha numero "+response[0].record_number+", pasar a "+response[0].machine_name.split('|')[0]);
                                this.increaseCalledTimes(response[0].id);
                                
							}
						}catch{
							swal('Error', "No fue posible conectar con aplicación HAP", 'error');
						}
					}.bind(this), 500);
				}
			}
		}		
	}

	async increaseCalledTimes(caller_id, machine_name){
		await callerActionHistoryInchreaseCalledTimes(caller_id);
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12 form-group">
                <div className='col-xs-9' style={{marginTop:15}}>
					<div className='col-xs-12 no-padding'>
						<div className='col-xs-12 col-sm-1'>
							<img src={this.props.logo_1} className="img-responsive" />
						</div>
						<div className='col-xs-12 col-sm-11'>
							<h1 className='center'>{this.state.health_facilities_name}</h1>
						</div>
					</div>
                    <div className='col-xs-12 no-padding'>
						{this.state.list_called.length > 0 ?
							<div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'80vh'}}>
								<div className='col-xs-8 form-group card'>
									<div className='col-xs-4 no-padding card-info center'>											
										<h2 style={{fontSize:'3em'}}>{t('content.list_called.table.caller_number')}</h2>
										<h1 style={{fontSize:'10em'}}>{this.state.list_called[0].record_number}</h1>
										<h3 style={{fontSize:'4em'}}>{moment(this.state.list_called[0].called_timestamp).format('HH:mm')}</h3>
									</div>
									<div className='col-xs-8 no-padding card-section center'>
										<h1 style={{fontSize:'5em'}}>{this.state.list_called[0].section}</h1>
										<h2 style={{fontSize:'4em'}}>{this.state.list_called[0].machine_name !== null && this.state.list_called[0].machine_name !== 'NULL' ? ' | '+this.state.list_called[0].machine_name.split('|')[0] : ''}</h2>
										
									</div>
								</div>
							</div>
						:null}
					</div>
                </div>
				<div className='col-xs-3' style={{height:'95vh', overflow:'scroll', marginTop:15}}>
					{this.state.list_called.length > 1 ?
						this.state.list_called.map((list, i)=>
							(i > 0 && i < 9) &&
								<div className='col-xs-12 form-group card'>
									<div className='col-xs-4 no-padding card-info center'>											
										<h4>{t('content.list_called.table.caller_number')}</h4>
										<h2>{list.record_number}</h2>
										<h5>{moment(list.called_timestamp).format('HH:mm')}</h5>
									</div>
									<div className='col-xs-8 no-padding card-section center'>
										<h2>{list.section}</h2>
										<h3>{list.machine_name !== null && list.machine_name !== 'NULL' ? ' | '+list.machine_name.split('|')[0] : ''}</h3>
										
									</div>
								</div>
						)
					: null}
					
				</div>
			</div>
		)
	}
}

export default translate('translations')(Caller);